import GPIProperties from "./GPIProperties";

window.GPIProperties = GPIProperties;
